import { deClientPortalValueCheckPageLayout } from './ValueCheck/ValueCheckLayout/ValueCheckPageLayout'

export const deClientPortalValueCheckPages = {
    valueCheckPageLayout: deClientPortalValueCheckPageLayout,
}
